import styled from "styled-components"
import {IconButton} from "@irati/ui/src/Button"

const StyledIconButton = styled(IconButton)`
  position: relative;
  ${(props) => (props.top ? `top: ${props.top}px` : "")}
  margin-left: 5px;
`

export default StyledIconButton
